<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode" @onChange="onChange">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "维修管理", path: `/fix/list` },
        { name: "维修列表", path: `/fix/list` },
        { name: "添加维修记录" },
      ],
      form: {
        type: 1,
        carid: undefined,
        articleid: undefined,
        rstarttime: undefined,
        money: undefined,
        repair: undefined,
        photo: undefined,
        photo_front: undefined,
        photo_back: undefined,
        mileage: undefined,
        mileage_image: undefined,
      },
      rules: {
        type: [
          { required: true, message: "请选择车辆类型", trigger: "blur" },
        ],
        carid: [
          { required: true, message: "请选择车牌号", trigger: "blur" },
        ],
        articleid: [
          { required: true, message: "请选择维保类型", trigger: "blur" },
        ],
        rstarttime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        money: [
          { required: true, message: "请填写金额", trigger: "blur" },
        ],
        mileage: [
          { required: true, message: "请填写行驶里程", trigger: "blur" },
        ],
        photo: [
          { required: true, message: "请上传维保票据", trigger: "blur" },
        ],
        photo_front: [
          { required: true, message: "请上传维修前照片", trigger: "blur" },
        ],
        photo_back: [
          { required: true, message: "请上传维修后照片", trigger: "blur" },
        ],
        mileage_image: [
          { required: true, message: "请上传行驶里程图片", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "车辆类型",
          keyName: "type",
          err: "请选择",
          type: "select",
          options: [
            { label: '车头', value: 1 },
            { label: '挂车', value: 2 },
          ],
        },
        {
          label: "车牌号",
          keyName: "carid",
          err: "请选择车牌号",
          type: "select",
        },
        {
          ...this.ctrls.fleet,
          keyName: 'fleet_name',
          disabled: true,
        },
        {
          label: "维保类型",
          keyName: "articleid",
          err: "请选择",
          type: "select",
          options: [],
        },
        {
          label: "维保时间",
          keyName: "rstarttime",
          err: "请选择时间",
          type: "date",
          pickerOptions: {
            disabledDate: (time) => {
              const today = new Date().setHours(0, 0, 0, 0);
              const sevenDaysAgo = today - 6 * 24 * 3600 * 1000; // 含当天共7天
              return time.getTime() > today || time.getTime() < sevenDaysAgo;
            }
          },
        },
        {
          label: "花费金额（元）",
          keyName: "money",
          err: "请填写金额",
          type: "number",
        },
        {
          label: "行驶里程",
          keyName: "mileage",
          err: "请填写行驶里程",
          type: "number",
        },
        {
          label: "备注",
          keyName: "repair",
          err: "请填写内容",
          type: "textarea",
          rows: '3',
          className: 'block',
        },
        
        {
          label: "维修前照片",
          keyName: "photo_front",
          type: "file",
          ptype: "repair",
          tips: "最多上传5张图片",
          max: 5,
        },
        {
          label: "维修后照片",
          keyName: "photo_back",
          type: "file",
          ptype: "repair",
          tips: "最多上传5张图片",
          max: 5,
          className: 'unton',
        },

        {
          label: "行驶里程图片",
          keyName: "mileage_image",
          type: "file",
          ptype: "repair",
          tips: "最多上传2张图片",
          max: 2,
        },
        {
          label: "维保票据",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "repair",
          max: 2,
        },
      ],
      cars0: [],
      cars: [],
      trailer0: [],
      trailer: [],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }

      delete params['fleet_name']

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'repair_shop',
      }
    },

    setOptions({ driver, trailer, article, reunit }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'carid') {
          if (driver && driver.length) {
            this.cars0 = driver
            this.cars = driver.map(v => {
              return {
                label: v.license,
                value: v.id,
              }
            })
          }
          if (trailer && trailer.length) {
            this.trailer0 = trailer
            this.trailer = trailer.map(v => {
              return {
                label: v.license,
                value: v.id,
              }
            })
          }
          c.options = [...this.cars]
        } else if (c.keyName == 'articleid' && article.length) {
          c.options = article.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        } else if (c.keyName == 'maunit' && reunit.length) {
          c.options = reunit.map(v => {
            return {
              label: v.maunit,
              value: v.maunit,
            }
          })
        }
        // if (maunit) {
        //   this.form.articleid = maunit.articleid
        //   this.form.maunit = maunit.maunit
        // }
        this.$forceUpdate()
      })
    },

    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['mileage_image'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        this.form[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else if (key === 'type') {
        this.$set(this.form, 'carid', null)
        this.$set(this.form, 'fleet_name', null)
        this.formCtrl.map(c => {
          if (c.keyName == 'carid') {
            if (value === 1) {
              c.options = [...this.cars]
            } else {
              c.options = [...this.trailer]
            }
          }
        })
      } else if (key === 'carid') {
        const { type } = this.form
        let arr = [...this.trailer]
        if (type == 1) {
          arr = [...this.cars0]
        }
        arr.map(c => {
          if (c.id == value) {
            // console.log({ ...c })
            this.$set(this.form, 'fleet_name', c.fleet_name)
          }
        })
      } else {
        this.form[key] = value;
      }
      // console.log({ ...this.form });
    },
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
